import React from "react";
import { useNavigate } from "react-router-dom";
import { FiChevronRight, FiExternalLink } from "react-icons/fi";
import { Helmet } from "react-helmet";

const AllGuide = () => {
  const navigate = useNavigate();

  const openChatGPTGuide = () => {
    navigate("/chatgpt-guide");
  };

  const openClaudeGuide = () => {
    navigate("/claude-guide");
  };

  const openGoogleFlowGuide = () => {
    navigate("/googleflow-guide");
};

const openGeminiGuide = () => {
    navigate("/gemini-guide");
};



  return (
    <>
      <Helmet>
        <title>Satyam AI</title>
        <meta
          name="description"
          content="Satyam AI — useful AI resources, guides and tools."
        />
      </Helmet>

      <main className="min-h-screen bg-[#111111] text-white">
        <div className="mx-auto flex min-h-screen w-full max-w-[620px] flex-col px-5 py-8 sm:px-6 sm:py-10">
          {/* Header */}
          {/* <header className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-[12px] border border-white/10 bg-[#242424] text-[16px] font-bold text-white shadow-sm">
                S
              </div>

              <div>
                <div className="text-[17px] font-semibold tracking-[-0.02em]">
                  Satyam AI
                </div>
                <div className="text-[11px] text-white/45">
                  AI tools, prompts & resources
                </div>
              </div>
            </div>

            <div className="flex h-10 w-10 items-center justify-center rounded-[12px] border border-white/10 bg-[#242424] text-white/75">
              <FiExternalLink className="text-[17px]" />
            </div>
          </header> */}

          {/* Profile / intro */}
          <section className="mt-16 text-center sm:mt-5">
           <div className="mx-auto h-[82px] w-[82px] overflow-hidden rounded-full border border-white/10 bg-[#191919] shadow-[0_12px_35px_rgba(0,0,0,0.3)]">
  <img
    src="/images/satyamprofile_121.jpg"
    alt="Profile"
    className="h-full w-full object-cover"
  />
</div>

            <h1 className="mt-5 text-[28px] font-semibold tracking-[-0.04em] sm:text-[32px]">
              Satyam AI
            </h1>

            <p className="mx-auto mt-2 max-w-[390px] text-[14px] leading-6 text-white/55">
              Simple AI resources to help you learn faster, create better,
              and get more from AI.
            </p>
          </section>

          {/* chatgpt resource card */}
         <section className="mt-8">
  <button
    type="button"
    onClick={openChatGPTGuide}
    className="group relative w-full rounded-[18px] border border-white/20 bg-[#1b1b1b] px-4 py-3 text-left shadow-[0_10px_30px_rgba(0,0,0,0.2)] transition duration-200 hover:-translate-y-[2px] hover:border-white/35 hover:bg-[#202020]"
  >
    <div className="flex items-center gap-3">
       <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-[11px] bg-black">
  <img
    src="/icons/chatgpt.png"
    alt="Google Flow"
    className="h-full w-full object-cover"
  />
</div>

      <div className="min-w-0 flex-1">
        <div className="mb-1 text-[9px] font-bold uppercase tracking-[0.12em] text-white/40">
          Free Resource
        </div>

        <h2 className="text-[16px] font-semibold tracking-[-0.02em] text-white">
          ChatGPT 600+ Shortcuts & Hacks
        </h2>

        <p className="mt-1 text-[12px] leading-4 text-white/50">
          Explore 600+ useful ChatGPT codes, shortcuts and prompt commands in
          one organized guide.
        </p>
      </div>

      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-white/50 transition group-hover:border-white/20 group-hover:text-white">
        <FiChevronRight className="text-lg" />
      </div>
    </div>

    <div className="mt-3 border-t border-white/[0.08] pt-2.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white/35">
      Open ChatGPT Guide
    </div>
  </button>
</section>

 {/* claude resource card */}
<section className="mt-8">
  <button
    type="button"
    onClick={openClaudeGuide}
    className="group relative w-full rounded-[18px] border border-white/20 bg-[#1b1b1b] px-4 py-3 text-left shadow-[0_10px_30px_rgba(0,0,0,0.2)] transition duration-200 hover:-translate-y-[2px] hover:border-white/35 hover:bg-[#202020]"
  >
    <div className="flex items-center gap-3">
       <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-[11px] bg-black">
  <img
    src="/icons/Claude.png"
    alt="Google Flow"
    className="h-full w-full object-cover"
  />
</div>

      <div className="min-w-0 flex-1">
        <div className="mb-1 text-[9px] font-bold uppercase tracking-[0.12em] text-white/40">
          Free Resource
        </div>

        <h2 className="text-[16px] font-semibold tracking-[-0.02em] text-white">
          Claude 50+ Shortcuts & Hacks
        </h2>

        <p className="mt-1 text-[12px] leading-4 text-white/50">
          Explore useful Claude shortcuts, commands and AI hacks in one
          organized guide.
        </p>
      </div>

      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-white/50 transition group-hover:border-white/20 group-hover:text-white">
        <FiChevronRight className="text-lg" />
      </div>
    </div>

    <div className="mt-3 border-t border-white/[0.08] pt-2.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white/35">
      Open Claude Guide
    </div>
  </button>
</section>

{/* Google Flow resource card */}
<section className="mt-8">
  <button
    type="button"
    onClick={openGoogleFlowGuide}
    className="group relative w-full rounded-[18px] border border-white/20 bg-[#1b1b1b] px-4 py-3 text-left shadow-[0_10px_30px_rgba(0,0,0,0.2)] transition duration-200 hover:-translate-y-[2px] hover:border-white/35 hover:bg-[#202020]"
  >
    <div className="flex items-center gap-3">

      {/* Icon */}
     <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-[11px] bg-black">
  <img
    src="/icons/googleFlowWhite.png"
    alt="Google Flow"
    className="h-full w-full object-cover"
  />
</div>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="mb-1 text-[9px] font-bold uppercase tracking-[0.12em] text-white/40">
          Free Resource
        </div>

        <h2 className="text-[16px] font-semibold tracking-[-0.02em] text-white">
   
          Google Flow 200+ Shortcuts & Hacks
        </h2>

        <p className="mt-1 text-[12px] leading-4 text-white/50">
          Explore Google Flow tips, prompts, workflows and useful AI
          techniques in one organized guide.
        </p>
      </div>

      {/* Arrow */}
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-white/50 transition group-hover:border-white/20 group-hover:text-white">
        <FiChevronRight className="text-lg" />
      </div>
    </div>

    {/* Bottom label */}
    <div className="mt-3 border-t border-white/[0.08] pt-2.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white/35">
      Open Google Flow Guide
    </div>
  </button>
</section>

{/* Gemini resource card */}
<section className="mt-8">
  <button
    type="button"
    onClick={openGeminiGuide}
    className="group relative w-full rounded-[18px] border border-white/20 bg-[#1b1b1b] px-4 py-3 text-left shadow-[0_10px_30px_rgba(0,0,0,0.2)] transition duration-200 hover:-translate-y-[2px] hover:border-white/35 hover:bg-[#202020]"
  >
    <div className="flex items-center gap-3">

      {/* Icon */}
     <div className="flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-[11px] bg-black">
  <img
    src="/icons/gemini.png"
    alt="Gemini"
    className="h-full w-full object-cover"
  />
</div>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <div className="mb-1 text-[9px] font-bold uppercase tracking-[0.12em] text-white/40">
          Free Resource
        </div>

        <h2 className="text-[16px] font-semibold tracking-[-0.02em] text-white">
   
          Gemini 30+ Shortcuts & Hacks
        </h2>

        <p className="mt-1 text-[12px] leading-4 text-white/50">
          Explore Gemini tips, prompts, workflows and useful AI techniques in one organized guide.
        </p>
      </div>

      {/* Arrow */}
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.04] text-white/50 transition group-hover:border-white/20 group-hover:text-white">
        <FiChevronRight className="text-lg" />
      </div>
    </div>

    {/* Bottom label */}
    <div className="mt-3 border-t border-white/[0.08] pt-2.5 text-[9px] font-semibold uppercase tracking-[0.12em] text-white/35">
      Open Gemini Guide
    </div>
  </button>
</section>

          <footer className="mt-auto pt-16 text-center">
            <p className="text-[11px] text-white/25">
              Satyam AI · AI resources & guides
            </p>
          </footer>
        </div>
      </main>
    </>
  );
};

export default AllGuide;
